define('navigationVM',['knockout', 'helpers', 'dialog-manager', 'user-answers'], function(ko, helpers, Dialog, UserAnswers) {
    'use strict';

    return function(parentVM, dataContext) {
        var self = this,
            data = dataContext.learning,
            dialog = new Dialog(),
            training = (data && data.training) ? data.training : null,
            entityVM = parentVM.entity,
            trainingVM = parentVM.training,
            courseComponentVM = parentVM.courseComponent,
            userAnswers = new UserAnswers();

        if (!data || !data.current) {
            return;
        }

        self.isCurrentPage = function(ID, status) {
            var currentID = entityVM.ID(),
                game = null;

            if (entityVM.isQuizGame()) {
                game = helpers.content.getQuizGame(currentID, training.contentEntities);
                return (game && game.ID === ID) ? true : false;
            } else if (entityVM.isQuizTask()) {
                return (ID === entityVM.parentID()) ? true : false;
            }

            return (status) ? true : false;
        };

        self.pages = ko.computed(function() {
            var currentID = entityVM.ID(),
                trainingMap = trainingVM.trainingMap() || [],
                arr = [],
                CSSwidth = (trainingMap.length) ? (100/trainingMap.length) + '%' : 100 + '%',
                CSSpreClass = (parentVM.modularNavigation.inCourse()) ? '' : 'goto',
                CSSclass = '',
                currentPage = false;

            for (var i = 0; i < trainingMap.length; i++) {
                CSSclass = CSSpreClass;

                if (!currentPage && self.isCurrentPage(trainingMap[i], currentID === trainingMap[i])) {
                    currentPage = true;
                    CSSclass += ' paging-current';
                } else if (userAnswers.isPageVisited(trainingMap[i])) {
                    CSSclass += ' paging-visited';
                }

                arr.push({
                    'ID': trainingMap[i],
                    'CSSwidth': CSSwidth,
                    'CSSclass': CSSclass
                });

            }

            return arr;
        });

        self.pagesHTML = ko.computed(function() {
            var res = '<ul>',
                pages = self.pages();

            for (var i = 0; i < pages.length; i++) {
                res += '<li data-id="' + pages[i].ID + '" style="width: ' + pages[i].CSSwidth + '" class="' + pages[i].CSSclass + '"> </li>';
            }

            res += '</ul>';

            return res;
        });

        self.menuTree = ko.computed(function() {
            var tree = [],
                page,
                entity,
                parentID,
                trainingMap = trainingVM.trainingMap(),
                contentContainerID = trainingVM.contentContainerID(),
                addChildren = function(arr, parentID, page) {
                    for (var i = 0; i < arr.length; i++) {
                        if (arr[i].ID === parentID) {
                            arr[i].children.push(page);
                        } else if (arr[i].children.length) {
                            addChildren(arr[i].children, parentID, page);
                        }
                    }
                };

            for (var i = 0; i < trainingMap.length; i++ ) {
                entity = trainingVM.getEntity(trainingMap[i]);

                if (!entity) {
                    continue;
                }

                parentID = entity.contentEntity.parentId;

                page = {
                    'ID': entity.contentEntityId,
                    'index': i + 1,
                    'title': entity.contentEntity.name,
                    'children': [],
                    'root': (parentID === contentContainerID) ? true :false
                };

                if (parentID !== '' && parentID !== contentContainerID) {
                    if (trainingMap.indexOf(parentID) === -1) {
                        tree.push(page);
                    } else {
                        addChildren(tree, parentID, page);
                    }
                } else {
                    tree.push(page);
                }
            }

            return tree;
        });

        self.menuTreeHTML = ko.computed(function() {
            var res = '<ul>',
                tree = self.menuTree(),
                CSSclass = '',
                currentID = entityVM.ID(),
                currentPage = false,
                content = function(page) {
                    var CSSclass = (page.root) ? 'nav-section' : 'nav-link';

                    if (!currentPage && self.isCurrentPage(page.ID, currentID === page.ID)) {
                        currentPage = true;
                        CSSclass += ' nav-current';
                    }

                    return  '<div class="goto ' + CSSclass + '" data-id="' + page.ID + '">' +
                            '   <div class="pagetitle">' + page.title + '</div><div class="pagenbr">' + page.index + '</div>' +
                            '</div>';
                },
                createTree = function(arr) {
                    var res = '';

                    for (var i = 0; i < arr.length; i++) {
                        if (arr[i].children.length) {
                            res += '<li class="nav-item nav-item-alt">' + content(arr[i]) + '</li>';
                            res += '<ul>';
                            res += createTree(arr[i].children);
                            res += '</ul>';
                        } else {
                            CSSclass = (arr[i].root) ? 'nav-item' : '';
                            res += '<li class="' + CSSclass + '">' + content(arr[i]) + '</li>';
                        }
                    }

                    return res;
                };

            res += createTree(tree);

            return res;
        });

        self.documentation = ko.computed(function() {
            return (dataContext.debugMode && dataContext.previewMode && !dataContext.productionMode) ? true : false;
        });

        self.docsJS = ko.computed(function() {
            return (window.location.href.indexOf('/app/') !== -1) ? '../docs/index.html' : 'docs/index.html';
        });

        self.docsCSS = ko.computed(function() {
            return (window.location.href.indexOf('/app/') !== -1) ? '../styleguide/index.html' : 'styleguide/index.html';
        });

        self.infoCounter = ko.computed(function() {
            var counter = (trainingVM.description()) ? 1 : 0,
                items = courseComponentVM.glossary.items();

            counter += (items) ? items.length : 0;

            if (self.documentation()) {
                counter += 2;
            }

            return counter;
        });

        self.navCSS = ko.computed(function() {
            return 'nav-offset-' + self.infoCounter();
        });

        self.infoCSS = ko.computed(function() {
            return 'nav-info-' + self.infoCounter();
        });

        self.toggleInfo = function(VM, e) {
            var target = e.currentTarget,
                dataset = (target) ? target.dataset : {},
                index = (dataset && dataset.hasOwnProperty('index')) ? dataset.index : undefined;

            if (!target || index === undefined) {
                return;
            }

            if (target.classList.contains('nav-current')) {

                target.classList.remove('nav-current');

                dialog.close({
                    type: 'dialog'
                });

            } else {
                var nav = document.getElementById('nav-info'),
                    current;

                if (nav) {
                    current = nav.querySelector('.nav-current');
                    if (current) {
                        current.classList.remove('nav-current');
                    }
                }

                target.classList.add('nav-current');

                setTimeout(function() {

                    dialog.open({
                        type: 'dialog',
                        label: (index === '-1') ? trainingVM.lang().info : courseComponentVM.glossary.getContent(index, 'title'),
                        mainClass: 'dialog dialog-glossary',
                        escapeClose: true,
                        content: (index === '-1') ? trainingVM.description() : courseComponentVM.glossary.getContent(index, 'body'),
                        onClose: function() {
                            if (document.querySelector('#nav-info .nav-current')) {
                                document.querySelector('#nav-info .nav-current').classList.remove('nav-current');
                            }
                        }
                    });

                    // helpers.layout.scrollTop();
                }, 0);
            }
        };
    }
});

